var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 0H2.44446C1.09387 0 0 1.09387 0 2.44446V7.33333H2.44446V2.44446H19.5556V19.5556H2.44446V14.6667H0V19.5555C0 20.9061 1.09387 22 2.44446 22H19.5556C20.9061 22 22 20.9061 22 19.5555V2.44446C22 1.09387 20.9061 0 19.5555 0Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65946 15.3817L10.3889 17.1111L16.5 11L10.3889 4.88886L8.65946 6.61833L11.8189 9.77779H0V12.2222H11.8189L8.65946 15.3817Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsLogout);
export default __webpack_public_path__ + "static/media/icon-us-logout.14d258760f69bb2235c18117996efe96.svg";
export { ForwardRef as ReactComponent };